<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Massolino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        I Massolino sono i supereroi di Serralunga d'Alba. Non solo hanno prodotto
                        alcuni dei migliori vini pregiati d'Italia dal 1896, ma i residenti devono ringraziare Giuseppe Massolino
                        per portare l'elettricità al villaggio. È anche giusto dire che i Massolino lo sono
                        responsabile dell'essere il Barolo quello che è oggi; nel 1934 i figli di Giuseppe, Giovanni e Angela
                        fondò il Consorzio per la Difesa del Barolo e del Barbaresco. Quindi, quando si tratta di aree di
                        competenza, la famiglia Massolino è piuttosto a posto su molte cose.
                    </div>

                    <div class="howto-title2">Una semplice filosofia</div>
                    <div class="howto-text">
                        I Massolino possiedono probabilmente la più interessante collezione di terroir di Serralunga (letteralmente
                        tradotto come “lunga sera”, che danno un'indicazione della posizione del paese), un grazioso
                        patchwork che produce i tre magici vini pregiati di Margheria, Parafada e Vigna Rionda.
                        Tra i produttori più piccoli e di qualità della regione (Fontanafredda, Luigi Pira e
                        Rivetto sono vicini di casa), la filosofia di Massolino è molto semplice: vogliono solo fare vino
                        con passione che rimangono fedeli al proprio terroir.
                    </div>

                    <div class="howto-title2">Il meglio del Barolo</div>
                    <div class="howto-text">
                        Oggi Massolino è alla quarta generazione; i fratelli Franco e Roberto si uniscono nel 1990 e
                        rimangono desiderosi di continuare la visione della loro famiglia. Alla ricerca di modi per infondere modernità con
                        tradizione hanno aggiornato le cantine (che sono gestite da Franco e dal suo mastro cantiniere
                        Giovanni Angeli di fama Vajra) e ha apportato modifiche significative ai vigneti (che sono
                        dominio di Roberto). Questi cambiamenti, compreso l'abbassamento dei rendimenti, sono stati accolti molto bene
                        e oggi Massolino siede comodamente in cima all'albero del Barolo.
                    </div>

                    <div class="howto-title2">Concentrato, potente e fiammeggiante (e questo è solo il vino)</div>
                    <div class="howto-text">
                        Mentre i prezzi di Bordeaux e Borgogna salgono, gli investitori di vini pregiati di tutto il mondo cacciano ulteriormente e
                        più lontano per gioielli rari, e Massolino vince ogni volta. Ugualmente importante,
                        Massolino ha ancora un prezzo relativamente ragionevole rispetto ad altri Barolo. Il loro superbo invecchiamento
                        (si pensi a 20-30 anni per la Margheria) unita alla scarsa produzione e al crescente interesse per la
                        zona vedrà senza dubbio Massolino catapultato sotto i riflettori del buon vino.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Massolino è stato nominato uno dei "25 migliori produttori di Barolo" secondo Tom Hyland nel suo articolo di Forbes del 2018.</li>
                            <li>Walter Speller di Jancis Robinson ha assegnato 18 punti al Vigna Rionda Riserva 2013, notando
                                “Elegante e persistente e dovrebbe invecchiare molto più a lungo, ma è difficile resistere. Bere
                                2024-2040.”
                            </li>
                            <li>Prezzi imperdibili quasi doppi rispetto a Vigna Rionda Riserva, solo piccole quantità
                                le migliori annate vengono trattenute per 10 anni dopo ulteriori 6 mesi ciascuna in botti e
                                tini di acciaio inox poi imbottigliati semplicemente con la dicitura “Dieci X Anni” in etichetta.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Massolino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die Familie Massolino sind die Superhelden von Serralunga d’Alba. Sie haben nicht nur produziert
                        Einige der besten erlesenen Weine Italiens seit 1896, aber die Bewohner haben es Giuseppe Massolino zu verdanken
                        für die Stromversorgung des Dorfes. Man kann auch mit Fug und Recht behaupten, dass es die Massolinos sind
                        verantwortlich dafür, dass Barolo das ist, was es heute ist; 1934 Giuseppes Kinder Giovanni und Angela
                        gründete das Konsortium zur Verteidigung von Barolo und Barbaresco. Wenn es also um Bereiche geht
                        Fachwissen, die Familie Massolino weiß in vielen Dingen genau das Richtige.
                    </div>

                    <div class="howto-title2">Eine einfache Philosophie</div>
                    <div class="howto-text">
                        Die Massolinos besitzen wahrscheinlich die interessanteste Sammlung von Terroirs in Serralunga (im wahrsten Sinne des Wortes).
                        übersetzt als „langer Abend“, was einen Hinweis auf die Lage des Dorfes gibt), ein hübscher
                        Patchwork, das die drei magischen erlesenen Weine Margheria, Parafada und Vigna Rionda hervorbringt.
                        Zu den kleineren, qualitätsorientierten Produzenten der Region (Fontanafredda, Luigi Pira und
                        Die Philosophie von Massolino (die Nachbarn von Rivetto sind) ist sehr einfach: Sie wollen einfach nur Weine herstellen
                        mit Leidenschaft, die ihrem Terroir treu bleiben.
                    </div>

                    <div class="howto-title2">Das Beste von Barolo</div>
                    <div class="howto-text">
                        Heute besteht Massolino in der vierten Generation; Die Brüder Franco und Roberto kamen 1990 dazu
                        sind weiterhin daran interessiert, die Vision ihrer Familie weiterzuführen. Auf der Suche nach Möglichkeiten, Modernität zu verleihen
                        Traditionell modernisierten sie die Keller (die von Franco und seinem Kellermeister verwaltet werden).
                        Giovanni Angeli von Vajra) und nahm bedeutende Veränderungen in den Weinbergen vor (die sind
                        Robertos Domäne). Diese Änderungen, einschließlich der Senkung der Erträge, wurden äußerst positiv aufgenommen
                        und heute sitzt Massolino bequem auf dem Barolo-Baum.
                    </div>

                    <div class="howto-title2">Konzentriert, kraftvoll und extravagant (und das ist nur der Wein)</div>
                    <div class="howto-text">
                        Während die Preise für Bordeaux und Burgund in die Höhe schießen, jagen Investoren edler Weine auf der ganzen Welt weiter
                        weiter weg nach seltenen Juwelen, und Massolino trumpft jedes Mal auf. Gleichermaßen wichtig,
                        Massolino ist im Vergleich zu anderen Barolos immer noch relativ günstig. Ihr hervorragendes Altern
                        (denken Sie an 20-30 Jahre für die Margheria) gepaart mit geringer Produktion und zunehmendem Interesse daran
                        Region wird Massolino zweifellos ins Rampenlicht der erlesenen Weine katapultieren.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Massolino wurde laut Tom Hyland in seinem Forbes-Artikel 2018 zu einem der „25 besten Barolo-Produzenten“ gekürt.</li>
                            <li>Walter Speller von Jancis Robinson vergab 18 Punkte an die Vigna Rionda Riserva 2013 und stellte fest:
                                „Elegant und anhaltend und sollte viel länger reifen, aber schwer zu widerstehen. Trinken
                                2024-2040.“
                            </li>
                            <li>Beeindruckende Preise, fast doppelt so hoch wie die von Vigna Rionda Riserva, nur in kleinen Mengen
                                Die besten Jahrgänge werden 10 Jahre lang zurückgehalten, danach jeweils weitere 6 Monate in Flaschen und Flaschen
                                Anschließend wird der Wein in Edelstahltanks abgefüllt, einfach mit dem Zusatz „Dieci X Anni“ auf dem Etikett.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Massolino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La famille Massolino sont les super-héros de Serralunga d'Alba. Non seulement ont-ils produit
                        certains des meilleurs vins fins d'Italie depuis 1896, mais les habitants doivent remercier Giuseppe Massolino
                        pour apporter l'électricité au village. Il est également juste de dire que les Massolinos sont
                        responsable du fait que Barolo soit ce qu'il est aujourd'hui ; en 1934 les enfants de Giuseppe Giovanni et Angela
                        a fondé le Consortium pour la défense de Barolo et Barbaresco. Ainsi, lorsqu'il s'agit de domaines de
                        expertise, la famille Massolino est au courant de beaucoup de choses.
                    </div>

                    <div class="howto-title2">Une philosophie simple</div>
                    <div class="howto-text">
                        Les Massolinos possèdent probablement la collection de terroirs la plus intéressante de Serralunga (littéralement
                        traduit par « longue soirée », qui donne une indication de la position du village), une jolie
                        patchwork qui produit les trois vins fins magiques de Margheria, Parafada et Vigna Rionda.
                        Parmi les petits producteurs de la région axés sur la qualité (Fontanafredda, Luigi Pira et
                        Rivetto sont voisins), la philosophie de Massolino est très simple - ils veulent juste faire des vins
                        avec passion qui reste fidèle à son terroir.
                    </div>

                    <div class="howto-title2">Le meilleur de Barolo</div>
                    <div class="howto-text">
                        Aujourd'hui Massolino en est à sa quatrième génération ; les frères Franco et Roberto se sont joints en 1990 et
                        désireux de poursuivre la vision de leur famille. À la recherche de moyens d'insuffler la modernité avec
                        traditionalité, ils ont mis à jour les caves (qui sont gérées par Franco et son maître de chais
                        Giovanni Angeli de renommée Vajra) et a apporté des changements importants dans les vignobles (qui sont
                        domaine de Roberto). Ces changements, y compris la baisse des rendements, ont été extrêmement bien accueillis
                        et aujourd'hui Massolino est assis confortablement au sommet de l'arbre Barolo.
                    </div>

                    <div class="howto-title2">Concentré, puissant et flamboyant (et ce n'est que le vin)</div>
                    <div class="howto-text">
                        Alors que les prix de Bordeaux et de Bourgogne montent en flèche, les investisseurs en vins fins du monde entier chassent plus loin et
                        plus loin pour les bijoux rares, et Massolino trouve à chaque fois des atouts. D'importance égale,
                        Massolino est toujours à un prix relativement raisonnable par rapport aux autres Barolos. Leur superbe vieillissement
                        (pensez 20-30 ans pour la Margheria) associée à une faible production et à un intérêt croissant pour la
                        région verra sans aucun doute Massolino catapulté sous les feux de la rampe des grands vins.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Massolino a été nommé l'un des "25 meilleurs producteurs de Barolo" selon Tom Hyland dans son article Forbes de 2018.</li>
                            <li>Walter Speller de Jancis Robinson a attribué 18 points à Vigna Rionda Riserva 2013, notant
                                "Élégant et persistant et devrait vieillir beaucoup plus longtemps, mais difficile à résister. Boire
                                2024-2040."
                            </li>
                            <li>Prix élevés près du double de ceux de Vigna Rionda Riserva, petites quantités en seulement
                                les meilleurs millésimes sont retenus 10 ans après 6 mois supplémentaires chacun en botti et
                                cuves inox puis mis en bouteille simplement avec la mention « Dieci X Anni » sur l'étiquette.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Massolino</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The Massolino family are the superheroes of Serralunga d’Alba. Not only have they been producing
                        some of Italy’s best fine wines since 1896, but the residents have Giuseppe Massolino to thank
                        for bringing electricity to the village. It’s also fair to say that the Massolinos are
                        responsible for Barolo being what it is today; in 1934 Giuseppe’s children Giovanni and Angela
                        founded the Consortium for the Defence of Barolo and Barbaresco. So when it comes to areas of
                        expertise, the Massolino family are pretty spot on about a lot of things.
                    </div>

                    <div class="howto-title2">A simple philosophy</div>
                    <div class="howto-text">
                        The Massolinos own probably the most interesting collection of terroirs in Serralunga (literally
                        translated as “long evening”, which give an indication of the village's position), a pretty
                        patchwork that produces the three magical fine wines of Margheria, Parafada and Vigna Rionda.
                        Among the smaller, quality-focused producers of the region (Fontanafredda, Luigi Pira and
                        Rivetto are neighbours), Massolino’s philosophy is very simple - they just want to make wines
                        with passion that remain loyal to its terroir.
                    </div>

                    <div class="howto-title2">The best of Barolo</div>
                    <div class="howto-text">
                        Today Massolino is in its fourth generation; brothers Franco and Roberto joined in 1990 and
                        remain keen to continue their family’s vision. Looking for ways to infuse modernity with
                        traditionality they updated the cellars (which are managed by Franco and his cellar master
                        Giovanni Angeli of Vajra fame) and made significant changes in the vineyards (which are
                        Roberto’s domain). These changes, including lowering yields, have been extremely well received
                        and today Massolino sits comfortably atop the Barolo tree.
                    </div>

                    <div class="howto-title2">Concentrated, powerful and flamboyant (and that’s just the wine)</div>
                    <div class="howto-text">
                        As prices for Bordeaux and Burgundy soar, fine wine investors the world over hunt further and
                        further afield for rare jewels, and Massolino comes up trumps every time. Equally important,
                        Massolino is still relatively reasonably priced compared to other Barolos. Their superb ageing
                        (think 20-30 years for the Margheria) coupled with low production and increasing interest in the
                        area will no doubt see Massolino catapulted into the fine wine spotlight.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Massolino was named one of “The Best 25 Producers of Barolo” according to Tom Hyland in his 2018 Forbes article.</li>
                            <li>Jancis Robinson’s Walter Speller awarded 18 points to 2013 Vigna Rionda Riserva, noting
                                “Elegant and persistent and should age for much longer, but hard to resist. Drink
                                2024-2040.”
                            </li>
                            <li>Commanding prices nearly twice that of Vigna Rionda Riserva, small quantities in only
                                the best vintages are held back for 10 years after an extra 6 months each in botti and
                                stainless steel vats then bottled simply with the addition “Dieci X Anni” on the label.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Massolino",
    head: {
        title: 'Massolino | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Massolino, a renowned wine producer in the Piedmont region of Italy. Enjoy the rich, complex flavors of their iconic red and white wines, made with traditional techniques and a passion for excellence.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
